import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { ModalService } from 'src/app/components/modals/modal.service';

import { TimelineDescriptionService } from 'src/app/components/timeline/timeline-description.service';
import { RvSortableItem, RvSortableService } from 'src/app/rv-sortable';
import { PlaylistService } from '../../services/playlist.service';

interface PlaylistItem extends RvSortableItem {
  objectReference: string;
  name: string;
  type: string;
  duration: number;
  playUntilDone?: boolean;
}

@Component({
  selector: 'playlist',
  templateUrl: './playlist.component.html',
  styleUrls: ['./playlist.component.scss'],
  standalone: false,
})
export class PlaylistComponent implements OnInit, OnChanges {
  @ViewChild('listElement') listElement: any;

  @Input() playlistItems: PlaylistItem[];

  sortableService: RvSortableService<PlaylistItem>;

  constructor(
    private modalService: ModalService,
    public playlistService: PlaylistService,
    public timelineDescription: TimelineDescriptionService,
    private host: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.sortableService = new RvSortableService<PlaylistItem>({
      items: this.playlistItems || [],
      getDisplayName: (item) => item.name,
      onReorder: (items) => this.handleReorder(items),
      hostElement: this.host,
      appendTo: '.scrollable-list',
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['playlistItems'] && this.sortableService) {
      this.sortableService.updateItems(this.playlistItems || []);
    }
  }

  manage(playlistItem) {
    this.playlistService.editPlaylistItem(playlistItem);
  }

  remove(playlistItem, index: number) {
    const removeButtonId = `removeButton-${index}`;
    const removeButton = document.getElementById(removeButtonId);
    const itemElement = removeButton?.closest(
      '.rv-sortable-item',
    ) as HTMLElement;
    const scrollableElement = removeButton?.closest(
      '.scrollable-list',
    ) as HTMLElement;

    if (!removeButton || !itemElement || !scrollableElement) {
      return;
    }

    const listScrollPosition = scrollableElement.scrollTop;

    this.modalService
      .confirm(
        'Remove Playlist Item?',
        'Are you sure you want to remove this item from the Playlist?',
        'Yes',
        'No',
        removeButtonId,
      )
      .then(() => {
        this.playlistService.removePlaylistItem(playlistItem);
        scrollableElement.scrollTo(
          0,
          listScrollPosition - itemElement.clientHeight,
        );
        this.focusNextElementRemoveButton(itemElement);
      })
      .catch(() => {
        removeButton.focus();
        scrollableElement.scrollTo(0, listScrollPosition);
      });
  }

  private focusNextElementRemoveButton(element: HTMLElement) {
    const focusedElement =
      element.nextElementSibling || element.previousElementSibling;
    if (focusedElement) {
      const nextButton = focusedElement.querySelector<HTMLButtonElement>(
        '[id^="removeButton-"]',
      );
      if (nextButton) {
        nextButton.focus();
      }
    }
  }

  private handleReorder(items: PlaylistItem[]): void {
    // this.changeDetectorRef.detectChanges();
  }

  sortItem(evt) {
    const oldIndex = evt.data.oldIndex;
    const newIndex = evt.data.newIndex;

    this.playlistService.moveItem(oldIndex, newIndex);
  }

  isAppleTVCompatible(playlistItem) {
    return this.playlistService.isItemAppleTVCompatible(playlistItem);
  }
}
